module.exports = __webpack_public_path__ + "front/img/b21.0bbd01e4.jpg";